import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  width: 401px;
  height: 790px;
  padding: 40px 34px;
  border-radius: 20px;
  background-color: ${props => (props.isLightMode ? '#ffffff' : '#242526')};
  box-shadow: 0px 8px 9px 0px rgba(0, 0, 0, 0.05), 0px 8px 9px 0px rgba(0, 0, 0, 0.05);

  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    width: calc(100% - 40px);
    height: auto;
    max-height: calc(100% - 40px);
    padding: 30px 20px;
    overflow-y: auto;
  }
`;
